<template>
  <div>
    <!-- <div class="anbox1" v-if="anbox">
      <div v-for="index in 5" :key="index" class="anboxclass" :id="'anbox'+index" >
        <img class="gildclass"  :id="'gild'+index" src="../../assets/img/icon.png" alt="">
      </div>
    </div>-->
    <div class="anbox" v-if="type==1||type==3">
      <img class="anboxclass1" src="/img/icon.png" alt />
      <div>+{{type==1?amount/1000000+'UMB':amount+'积分'}}</div>
    </div>
    <div class="anbox1" v-if="type==2||type==4">
      <img class="anboxclass1" src="/img/icon.png" alt />
      <div>-{{type==2?amount/1000000+'UMB':amount+'积分'}}</div>
    </div>
  </div>
</template>
<script>
export default{
  name: "UmAnimate",
  data(){
    return{
      type:0,
      amount:0
    }
  },
  // props:['anbox',"anbox1"],
  mounted(){
    var that=this
    var a={
      paymentnotice(ummsg){
        that.type=ummsg.noticetype
        that.amount=ummsg.Amount
        setTimeout(()=>{
          that.type=0;
        },3500)
      }
    }
    $UMCore.on(['msg'],a)
  }
}
</script>
<style lang="scss">
.anbox {
  position: fixed;
  left: 50%;
  text-align: center;
  top: -10%;
  // transform: translate(-50%,-50%);
  z-index: 999;
  width: 200px;
  animation: myfirst3 2.5s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
}
.anbox1 {
  position: fixed;
  left: 50%;
  text-align: center;
  top: 60%;
  // transform: translate(-50%,-50%);
  z-index: 999;
  width: 200px;
  animation: myfirst1 2.5s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
}
/* 金币动画-基础样式 */
.anboxclass1 {
  animation: myfirst2 2.5s;
  animation-delay: 2.5s;
  animation-iteration-count: infinite;
}
.anboxclass {
  animation-name: boxanname1;
  animation-duration: 1.5s;
  animation-delay: 1s;
  animation-timing-function: cubic-bezier(0, 0, 0, 0);
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
}
.gildclass {
  position: absolute;
  // top: 15%;
  // left: 50%;
  // margin-left: 50%;
  // margin-top: 50%;
  width: 5px;

  animation: myfirst 1.5s;
  animation-delay: 1s;
  animation-timing-function: cubic-bezier(0.14, -0.2, 1, 0.18);
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
}

/* 只动盒子的left就行 */
/* 第一个金币 */
#anbox1 {
  animation-name: boxanname1;
  animation-delay: 0.5s;
}
#gild1 {
  animation-delay: 0.5s;
}
@keyframes myfirst {
  0% {
  }
  10% {
    width: 15px;
  }
  20% {
    width: 25px;
  }
  100% {
    margin-top: 1000px;
    width: 40px;
    transform: rotateX(1500deg);
    opacity: 0;
  }
}
@keyframes myfirst1 {
  0% {
    top: 60%;
  }
  50% {
    top: -10%;
  }
  100% {
    top: -10%;
  }
}
@keyframes myfirst3 {
  0% {
    top: -10%;
  }
  50% {
    top: 60%;
  }
  100% {
    top: 60%;
  }
}
@keyframes myfirst2 {
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(360deg);
  }
  100% {
    transform: rotateY(0);
  }
}
@keyframes boxanname1 {
  0% {
  }
  100% {
    margin-left: 60%;
  }
}

/* 第二个金币 */
#anbox2 {
  animation-name: boxanname2;
  animation-delay: 0.7s;
}
#gild2 {
  animation-delay: 0.7s;
}
@keyframes boxanname2 {
  0% {
  }
  100% {
    margin-left: 20%;
  }
}

/* 第三个金币 */
#anbox3 {
  animation-name: boxanname3;
  animation-delay: 0.8s;
}
#gild3 {
  animation-delay: 0.8s;
}
@keyframes boxanname3 {
  0% {
  }
  100% {
    margin-left: 0%;
  }
}

/* 第四个金币 */
#anbox4 {
  animation-name: boxanname4;
  animation-delay: 0.3s;
}
#gild4 {
  animation-delay: 0.3s;
}
@keyframes boxanname4 {
  0% {
  }
  100% {
    margin-left: -20%;
  }
}

/* 第五个金币 */
#anbox5 {
  animation-name: boxanname5;
  animation-delay: 0.3s;
}
#gild5 {
  animation-delay: 0.3s;
}
@keyframes boxanname5 {
  0% {
  }
  100% {
    margin-left: -60%;
  }
}
</style>


// WEBPACK FOOTER //
// src/packages/animate/um-animate.vue